<template>
    <footer class="footer" id="footer">
        <div class="footerLogoText">
            <p class="footerText roboto400">Powered by</p>
            <span class="imgFooter">
                <img src="../../assets/images/logo_Digitel.png" class="img-fluid" alt="EnergyGo">
            </span>
        </div>
    </footer>
</template>
<script>
export default {
    name:'common-footer',
    data(){
        return{
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/footer/footer.vue